module.exports = __webpack_public_path__ + "img/tu_logo.12f9c0cc.png";